import React, { Component } from 'react'

class Preloader extends Component {
  constructor() {
    super()

    this.state = {
      hideLoader: {}
    }
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({
        hideLoader: { display: 'none' }
      })
    }, 2500)
  }

  render() {
    return (
      <div id="preloader" style={this.state.hideLoader}>
        <div id="status">
          <div className="preloader" aria-busy="true" aria-label="Loading, please wait." role="progressbar"></div>
        </div>
      </div>
    )
  }
}

export default Preloader
